import { EPayMode } from '@root/constant';
import create from 'zustand';

export interface IPayMethod {
  payMode: number;
}

export interface IState {
  list: IPayMethod[];
  loaded: boolean;
  setList: (v: IPayMethod[]) => void;
  setLoaded: (v: boolean) => void;
  resetInitData: () => void;
}

const _list = [{ payMode: EPayMode.PayPal }];

const usePayMethodState = create<IState>((set) => ({
  list: _list,
  loaded: false,
  setList: (list) => {
    return set(() => {
      return { list };
    });
  },
  setLoaded: (loaded) => {
    return set(() => {
      return { loaded };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        list: _list,
        loaded: false,
      };
    });
  },
}));

export default usePayMethodState;
